import acInterceptor from '../acInterceptor';
import { type ApiAdapter } from '@libs/app-bridge';
import { useUserStore } from '@libs/acp/store/user/useUserStore';

const identityBaseURL = import.meta.env.VITE_ACP_IDENTITY;

export const identityApi: ApiAdapter = {
  post: (url, data) => {
    const { access_token, refresh_token } = useUserStore.getState().authenticatedUser.acp.auth;

    return acInterceptor({
      baseURL: identityBaseURL,
      headersBeforeRequest: {
        Authorization: `Bearer ${access_token}`,
        'Refresh-Token': refresh_token,
      },
    })
      .Post(url, data)
      .send();
  },
};
